/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Guide_Details_TabInputs */

const en_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide Details`)
};

const fr_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails du guide`)
};

const de_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfadendetails`)
};

const it_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli della guida`)
};

const ru_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подробности руководства`)
};

const es_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de la guía`)
};

const zh_cn2_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指南详情`)
};

const ja_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドの詳細`)
};

const hi_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गाइड विवरण`)
};

const pt_pt2_knp_manager_guide_details_tab = /** @type {(inputs: Knp_Manager_Guide_Details_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do guia`)
};

/**
* | output |
* | --- |
* | "Guide Details" |
*
* @param {Knp_Manager_Guide_Details_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_guide_details_tab = /** @type {((inputs?: Knp_Manager_Guide_Details_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Guide_Details_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_guide_details_tab(inputs)
	if (locale === "de") return de_knp_manager_guide_details_tab(inputs)
	if (locale === "it") return it_knp_manager_guide_details_tab(inputs)
	if (locale === "ru") return ru_knp_manager_guide_details_tab(inputs)
	if (locale === "es") return es_knp_manager_guide_details_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_guide_details_tab(inputs)
	if (locale === "ja") return ja_knp_manager_guide_details_tab(inputs)
	if (locale === "hi") return hi_knp_manager_guide_details_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_guide_details_tab(inputs)
	return en_knp_manager_guide_details_tab(inputs)
});